// extracted by mini-css-extract-plugin
export default {"page":"stack_page__FJzHT"};